import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";

export const CAREGIVERS_CGID_QUERY_KEY = "CAREGIVERS_CGID_QUERY_KEY";
export const CAREGIVERS_PID_KEY = "CAREGIVERS_PID_KEY";

export const useCareGiversByIdQuery = (caregiverUserId) => {
  return useQuery({
    queryKey: [CAREGIVERS_CGID_QUERY_KEY, caregiverUserId],
    retry: false,
    queryFn: async () => {
      const session = await fetchAuthSession();
      const { body } = await get({
        apiName: "careprovidersapi",
        path: "/caregivers/" + caregiverUserId,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
        },
      }).response;
      return await body.json();
    },
    placeholderData: [],
    enabled: !!caregiverUserId
  });
};

export const useCareGiversByPatientIdQuery = (patientUserId) => {
  return useQuery({
    queryKey: [CAREGIVERS_PID_KEY, patientUserId],
    retry: false,
    queryFn: async () => {
      const session = await fetchAuthSession();
      const { body } = await get({
        apiName: "careprovidersapi",
        path: "/caregivers/patient/" + patientUserId,
        options: {
          headers: {
            Authorization: session.tokens.idToken.toString(),
          },
        },
      }).response;
      return await body.json();
    },
    placeholderData: [],
    enabled: !!patientUserId
  });
};
